import HttpFactory from '~/repository/factory';

class LocaleRepository extends HttpFactory {

    async changeLocale(locale?: string): Promise<Record<string, any>> {
        return await this.getJson(`change-locale/${locale}`);
    }
}

export default LocaleRepository;